export const HIGHLIGHTED_FIELDS_REQUIRED_MSG = 'All highlighted fields are required';
export const NOT_INITILIZED = 'NOT_INITILIZED';
